import * as Sentry from  '@sentry/nextjs'

import { LIVE_SITE_CMS } from '@constants'

export const wordpressPost = async (url, data, site) =>
  fetch(`${LIVE_SITE_CMS}/${site}/wp-json/${url}`, data).then((resp) => resp.json()).catch((err) => {
    Sentry.captureException(err)
    throw err;
  })
